export type Review = {
  author: string;
  rating: number;
  text: string;
  when: string;
};

// Fallback statico usato solo se il DB non fornisce i valori aggiornati.
// I valori "vivi" arrivano da site_settings (google_rating, google_reviews_count)
// via useGoogleReviewsStats(): il cliente li aggiorna dall'admin. Struttura
// pronta per essere sostituita da una chiamata Google Places API senza
// toccare i consumer.
export const REVIEWS_AGGREGATE_FALLBACK = {
  rating: 4.7,
  count: 33,
  url: "https://www.google.com/maps/search/?api=1&query=La+Bottega+delle+Carni+da+Marco+Campobasso",
};

export const REVIEWS: Review[] = [
  {
    author: "Fabrizio Morgese",
    rating: 5,
    text: "Azienda familiare di persone che amano il proprio lavoro e si vede! Ottime carni, prezzi giusti, assortimento attento alle realtà locali. Da provare l'Abatina, salume tipico di Campobasso.",
    when: "5 anni fa",
  },
  {
    author: "Elena Passarelli",
    rating: 5,
    text: "Ormai il mio macellaio di fiducia! Ottima carne. L'altro giorno ho mangiato le bombette pugliesi: decisamente una buona idea per un secondo diverso dal solito!",
    when: "5 anni fa",
  },
  {
    author: "Francesca",
    rating: 5,
    text: "Macelleria con ottime carni e ottimo rapporto qualità prezzo. Ogni giorno si trovano nuove e creative portate.",
    when: "3 anni fa",
  },
  {
    author: "Angelica Iacobucci",
    rating: 5,
    text: "La migliore carne di Campobasso. Qualità eccellente e personale sempre disponibile e pronto a fornire al cliente la migliore assistenza.",
    when: "5 anni fa",
  },
  {
    author: "vincenzo giancola",
    rating: 5,
    text: "Ottime carni locali, salumi e formaggi e la famosa ABATINA di Campobasso, sia fresca che essiccata.",
    when: "5 anni fa",
  },
  {
    author: "Mario Cosimato",
    rating: 5,
    text: "Sono di Salerno e quando mi trovo a Campobasso faccio volentieri la scorta. Ottima carne!",
    when: "5 anni fa",
  },
  {
    author: "Antonietta Fede",
    rating: 5,
    text: "In questo negozio trovi di tutto e di ottima scelta. Carni di ottima qualità locali e ottime anche le abatine e tutti gli insaccati.",
    when: "7 anni fa",
  },
  {
    author: "Renato Di Toro",
    rating: 4,
    text: "Carni di ottima qualità. Salumi ed insaccati come da tradizione campobassana.",
    when: "7 anni fa",
  },
  {
    author: "Daniele Di Stefano",
    rating: 5,
    text: "Santino e Giovanna gestiscono questa macelleria in maniera efficace e cordiale. Ottima carne!",
    when: "10 anni fa",
  },
  {
    author: "Manuela Rocco",
    rating: 5,
    text: "Ottima carne, personale molto disponibile, ottimo rapporto qualità prezzo.",
    when: "5 anni fa",
  },
  {
    author: "Elisa Moschella",
    rating: 5,
    text: "Il punto di incontro tra qualità, cortesia e tradizione.",
    when: "5 anni fa",
  },
  {
    author: "Miki",
    rating: 4,
    text: "Buon assortimento di carni molisane, preparazioni da asporto. Lo consiglio.",
    when: "6 anni fa",
  },
  {
    author: "Federica Padovano",
    rating: 5,
    text: "La migliore macelleria della zona.",
    when: "4 anni fa",
  },
  {
    author: "Kan Muriishi",
    rating: 5,
    text: "Li conosco da una vita e adoro i loro prodotti.",
    when: "3 anni fa",
  },
];